export class BookingSlotDTO {

    constructor(
        public dateTime: string
    ) { }
}
